import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { MenuItem, SubMenuItem, ForestAreaIcon, DeadTreeIcon, InfestedTreeIcon, HealthyTreeIcon, OtherIcon, OtherHealthIcon, BirchIcon, PineIcon, SpruceIcon, DeleteTreeIcon, TreeMenuIcon } from './MapActionMenu';
import ReactTooltip from 'react-tooltip';
import { isEmpty } from 'lodash';

const Label = styled.span`
  display: block;
  font-weight: bold;
  font-size: 0.875rem;
  min-width: 150px;
  margin-bottom: 0.5rem;
`;

const Separator = styled.div`
  height: 1px;
  margin: 0.5rem 0;
  background-color: ${({theme}) => theme.colors.bg_gray};
`;

const ActionsWrapper = styled.div`
  padding: 0.5rem 0.75rem;
  background-color: ${({theme}) => theme.colors.white};
  box-shadow: 0 0 20px rgb(34 36 38 / 15%);
`;

const ForestMapMenu = ({GIS, addFeature, epsg}) =>{
  const {selectedTool, setSelectedTool, setUnsavedChanges, featuresData, setDeletedFeature} = useDroneDetailContext();
  const [selectedTreeAction, setTreeAction] = useState(null);

  const handleAddPolygon = () =>{
    setSelectedTool("polygon");
    GIS.Edit.drawFeatures('polygon', 'Polygon', false, (id) => {
      GIS.Layer.setFeatureStyleByID('polygon', 'areaPile', id)
      GIS.Layer.getFeatureByID('polygon', id, { attribute: 'id', epsg: `EPSG:${epsg}`, format: 'geojson' }, geometry => {
        setUnsavedChanges(true);
        GIS.Layer.setFeatureAttributeByID('polygon','label', `${id}`, id)
        addFeature({
          featureId: id,
          geometry
        });
    });
    },  {incrementId: true, style:'editing'})
  }
  const handleAddTree = (type) =>{
    //Todo open point type selection menu
    handleAddPoint(type);
  }
    const handleAddPoint = (type) =>{
      setTreeAction(type);
      GIS.Edit.drawFeatures('tree', 'Point', false, (id) => {
        GIS.Layer.setFeatureAttributeByID('tree','label',type, id)
        GIS.Layer.getFeatureByID('tree', id, { attribute: 'id', epsg: `EPSG:${epsg}`, format: 'geojson' }, geometry => {
          setUnsavedChanges(true);
          addFeature({
            featureId: id,
            id:id,
            geometry,
            label: type
          });
      });
      },  {incrementId: true, style:type})
  }
  const handleDeletePoint = () => {
    setTreeAction('delete');
    GIS.Interaction.setCallback('Identify', {}, (X, Y) => {
    const pointIds = GIS.Layer.getFeatureIDsAtCoordinate('tree', [X, Y], { attribute: 'id', strategy: 'closest', tolerance: 1 });
    if(!isEmpty(pointIds)){
    console.log(pointIds[0])
    const item = featuresData.find(f=>f.properties.id === pointIds[0]);
    console.log(item)
    setUnsavedChanges(true);
    setDeletedFeature(item);
    }
    })
  }

  useEffect(() => {
    window.addEventListener('keydown', (key) => {
        if(key.key === 'Escape' && ['polygon'].includes(selectedTool)) {
          setSelectedTool(null);
        }

        if(key.key === 'Escape' && ['treeType'].includes(selectedTool)) {
          GIS.Edit.commit();
          setSelectedTool(null);
          setTreeAction(null);
        }
    });
  }, [selectedTool]);

  return (
    <>
    <ReactTooltip type='light'/>
    <MenuItem data-tip="Compartment" active={selectedTool === 'polygon'} onClick={()=>{GIS.Edit.commit();handleAddPolygon()}}>
      <ForestAreaIcon />
    </MenuItem>
    <MenuItem data-tip="Edit Tree Label" active={selectedTool === 'treeType'}  onClick={() => {
      GIS.Edit.commit();
      setSelectedTool(selectedTool === 'treeType' ? null : 'treeType');
      setTreeAction(null);
    }}>
      <TreeMenuIcon />
    </MenuItem>

    {
      selectedTool === 'treeType' && (
        <ActionsWrapper>
          <div>
            <Label>Tree species</Label>
            <SubMenuItem active={selectedTreeAction === 'spruce'} onClick={()=>{GIS.Edit.commit();handleAddTree("spruce");}}>
              <SpruceIcon />
              <span>Spruce</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'pine'} onClick={()=>{GIS.Edit.commit();handleAddTree("pine");}}>
              <PineIcon />
              <span>Pine</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'birch'} onClick={()=>{GIS.Edit.commit();handleAddTree("birch");}}>
              <BirchIcon />
              <span>Birch</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'other'} onClick={()=>{GIS.Edit.commit();handleAddTree("other");}}>
              <OtherIcon />
              <span>Other</span>
            </SubMenuItem>
          </div>

          <Separator />

          <div>
            <Label>Health condition</Label>
            <SubMenuItem active={selectedTreeAction === 'healthy'} onClick={()=>{GIS.Edit.commit();handleAddTree("healthy");}}>
              <HealthyTreeIcon />
              <span>Healthy</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'infested'} onClick={()=>{GIS.Edit.commit();handleAddTree("infested");}}>
              <InfestedTreeIcon />
              <span>Infested</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'dead'} onClick={()=>{GIS.Edit.commit();handleAddTree("dead");}}>
              <DeadTreeIcon />
              <span>Dead</span>
            </SubMenuItem>
            <SubMenuItem active={selectedTreeAction === 'other_health'} onClick={()=>{GIS.Edit.commit();handleAddTree("other_health");}}>
              <OtherHealthIcon />
              <span>Other</span>
            </SubMenuItem>
          </div>

          <Separator />

          <div>
            <SubMenuItem active={selectedTreeAction === 'delete'} onClick={()=>{GIS.Edit.commit();handleDeletePoint();}}>
              <DeleteTreeIcon />
              <span>Delete</span>
            </SubMenuItem>
          </div>

        </ActionsWrapper>
      )
    }
    </>
  );
}

export default ForestMapMenu;